export default "__VITE_ASSET__0512ae92__"